import React from 'react';
import MediaDropzone from '../MediaDropzone/MediaDropzone';

export default function MultiImageUpload({
  label = 'Bilder hierher ziehen oder klicken',
  type = 'post',
  name = 'Post',
  maxSizeMB = 64,
  images = [],
  onChange,
  onError,
}) {
  return (
    <MediaDropzone
      multiple
      label={label}
      hint="Mehrere Dateien möglich · JPG, PNG, GIF, WebP"
      type={type}
      name={name}
      maxSizeMB={maxSizeMB}
      images={images}
      onImagesChange={onChange}
      onError={onError}
    />
  );
}
